/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SelectedAppointmentTypesInfo/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SelectedAppointmentTypesInfo({
  children,
  viewPath = "/App/Account/Content/Calendar/New/CollapsibleSidebar/SelectedAppointmentTypesInfo"
  
}) {
let tabSelectedSidebarAppointmentTypesValueData = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.sidebar_appointment_types',
format: fromFormat.isNotEmptyList,
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let constantData = 'Showing availability for'
let tabSelectedSidebarAppointmentTypesValueData1 = fromData.useDataFormat({ viewPath,
context: 'tab',
path: 'selected.sidebar_appointment_types',
format: fromFormat.listLength,
})
let constantData1 = 'appointment types'
let aggregateData = fromAggregate.join(constantData, tabSelectedSidebarAppointmentTypesValueData1, constantData1)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let onClick = fromHelpers.useOnClearAppointmentTypes({
  children,
  viewPath
  
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<fromFlow.When is={tabSelectedSidebarAppointmentTypesValueData}>
<div
  data-testid="SelectedAppointmentTypesInfo.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z164paP': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-Z164paP': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 fontSize={dtTypographyFontsizeM}
 maxWidth="70%"
 data="'Showing availability for'"
 data="tab.selected.sidebar_appointment_types"
 format="/Data/format.js listLength"
 aggregate="/Data/aggregate.js join"
 data="'appointment types'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 id="appointment_types"
 onClick={onClick}
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 text="Clear All"
/>
)}
</TysiaButton>
</div>
</fromFlow.When>
{children}
</React.Fragment>)
}